<div class="table-wrapper height-full">
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th *ngIf="batch" class="check no-icon">
            <input [(ngModel)]="batchValue" (ngModelChange)="onBatchAll()" [disabled]="!rows.length" class="form-check-input" type="checkbox" />
          </th>
          <th *ngFor="let column of columns" scope="col" [class]="column.className">
            <span (click)="onSort(column)" class="head-title" [ngClass]="{'sort': column.sort}" [tooltip]="column.popover"
              [tooltipPlacement]="column.popoverPosition || 'top'">
              {{column.title}}
              <span class="icon-arrow-down" *ngIf="column.sortDirection === 'desc'"></span>
              <span class="icon-arrows-up" *ngIf="column.sortDirection === 'asc'"></span>
            </span>
          </th>
          <th *ngIf="actions.length" class="no-icon text-end w-sm" scope="col" tooltip="Actions available for each individual test" tooltipPlacement="top">
            <span class="head-title">Actions</span>
          </th>
        </tr>
      </thead>

      <tbody *ngIf="rows.length">
        <tr *ngFor="let row of rows;index as i" class="position-relative" [ngClass]="extractClassName(row.className, [row])">
          <td *ngIf="row.tables && row.tables.length" class="sub-tables" [colSpan]="getColumnsLength()">
            <app-table *ngFor="let sub of row.tables" [columns]="sub.columns" [rows]="sub.rows"></app-table>
          </td>

          <ng-container *ngIf="!row.tables || !row.tables.length">
            <th *ngIf="batch" class="check" [ngClass]="{'bg-neutral-n2': i % 2 == 0}"><input [disabled]="row.batchDisabled" [(ngModel)]="row.batch"
                (ngModelChange)="onBatch()" class="form-check-input" type="checkbox" /></th>
            <ng-container *ngFor="let column of columns">
              <td *ngIf="column.type === 'date'" [ngClass]="extractClassName(column.cellClassName, [column, row])">
                <span class="d-block">{{extractValue(column, row)[0]}}</span>
                <span class="d-block">{{extractValue(column, row)[1]}}</span>
              </td>
              <td *ngIf="column.type === 'html'" (click)="onCellClick(column, row)" [innerHTML]="extractValue(column, row)"
                [ngClass]="extractClassName(column.cellClassName, [column, row])"></td>
              <td *ngIf="column.type === 'text' || !column.type" (click)="onCellClick(column, row)"
                [ngClass]="extractClassName(column.cellClassName, [column, row])">{{ extractValue(column, row) }}</td>
              <td *ngIf="column.type === 'input-switch'" [ngClass]="extractClassName(column.cellClassName, [column, row])">
                <div class="form-check form-switch">
                  <input type="checkbox" class="form-check-input" [(ngModel)]="row.data[column.prop]" (change)="onSwitch(column, row)">
                </div>
              </td>
            </ng-container>

            <td class="w-xxs" *ngIf="actions.length">
              <div class="drop-start text-end d-flex justify-content-end align-items-center gap-10"
                *ngIf="maxDisplayActions && getVisibleTableActions(row.data) > maxDisplayActions">
                <ng-container *ngIf="row.data.relatedTestId">
                  <div *ngIf="!row.data._child && !row.data._showAll" tooltip="Show backup test" tooltipPlacement="top"
                    (click)="onAction({name:'showAll', icon: ''}, row)">
                    <span class="icon-add action-icons cp"></span>
                  </div>
                  <div *ngIf="row.data._showAll" tooltip="Hide backup test" tooltipPlacement="top" (click)="onAction({name:'hideAll', icon: ''}, row)">
                    <span class="icon-arrow-up action-icons cp"></span>
                  </div>
                </ng-container>

                <a class="dropdown-toggle" [dropdown]="actionsContent" dropdownPlacement="left-start" dropdownHideAfterClick="true"
                  [ngClass]="{'has-dot': !!row.data.commentId}"><span class="icon-more"></span></a>

                <ul #actionsContent class="dropdown-menu">
                  <li *ngFor="let a of actions" [hidden]="isActionShow(a, row) === false">
                    <a (click)="onAction(a, row);" class="dropdown-item">
                      <span *ngIf="!a.iconExtraData" class="{{a.icon}} action-icons"></span>
                      <span *ngIf="a.iconExtraData" class="{{a.icon}} action-icons" [innerHTML]="a.iconExtraData"></span>
                      <span class="action-text"> {{a.title}}</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="action-icons-horizontal" *ngIf="!maxDisplayActions || getVisibleTableActions(row.data) <= maxDisplayActions">
                <div *ngFor="let action of actions" [hidden]="isActionShow(action, row) === false" [tooltip]="action.title" tooltipPlacement="top"
                  (click)="onAction(action, row)">
                  <span class="{{action.icon}} action-icons cp"></span>
                </div>
              </div>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!rows.length" class="table-empty-state position-relative my-40">
      <div class="state-wrapper" [attr.colspan]="columns.length + 2">
        <div class="icon-holder mb-20">
          <img src="/img/table-empty-illustration.svg" alt="img description" />
        </div>
        <p class="mb-10 text-lg">No data</p>
        <p class="mb-20">No data found</p>
      </div>
    </div>

  </div>

</div>
